import React, { useState } from "react";
import { Screen } from "@jugl-web/utils/utils/ScreenTransitionManager";
import { useRestApiProvider } from "@jugl-web/rest-api";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import {
  ManageAccountsDrawerContext,
  ManageAccountsDrawerContextValue,
} from "./ManageAccountsDrawerContext";
import { ManageAccountsDrawerScreenToParametersMap } from "../types";

export const ManageAccountsDrawerProvider: React.FC<{
  isInboxModule?: boolean;
  children: React.ReactNode;
}> = ({ children, isInboxModule = false }) => {
  const { integrationsApi } = useRestApiProvider();
  const { entityId } = useEntitySelectedProvider();

  const [isManageAccountDrawerOpen, setIsManageAccountDrawerOpen] =
    useState<Screen<ManageAccountsDrawerScreenToParametersMap>>();

  const {
    data: crmConfig,
    isFetching: isCRMConfigFetching,
    isLoading: isCRMConfigLoading,
    isError: isCRMConfigError,
    refetch: refetchCRMConfig,
  } = integrationsApi.useGetCRMConfigQuery({ entityId });

  const value: ManageAccountsDrawerContextValue = React.useMemo(
    () => ({
      isManageAccountDrawerOpen,
      openManageAccountDrawer: setIsManageAccountDrawerOpen,
      isInboxModule,
      crmConfig,
      isCRMConfigFetching,
      isCRMConfigLoading,
      isCRMConfigError,
      refetchCRMConfig,
    }),
    [
      isManageAccountDrawerOpen,
      isInboxModule,
      crmConfig,
      isCRMConfigFetching,
      isCRMConfigLoading,
      isCRMConfigError,
      refetchCRMConfig,
    ]
  );

  return (
    <ManageAccountsDrawerContext.Provider value={value}>
      {children}
    </ManageAccountsDrawerContext.Provider>
  );
};
